var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 480 480"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 32,
    d: "M354.288 373.84C323.536 400.128 283.616 416 240 416c-97.2 0-176-78.8-176-176M125.712 106.16C156.464 79.872 196.384 64 240 64c97.2 0 176 78.8 176 176"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M424.32 307.519c-3.958 5.938-12.682 5.938-16.641 0l-45.314-67.972c-4.431-6.646.333-15.547 8.32-15.547h90.63c7.987 0 12.751 8.901 8.32 15.547zM55.68 172.481c3.958-5.938 12.682-5.938 16.64 0l45.315 67.972c4.431 6.646-.333 15.547-8.32 15.547h-90.63c-7.987 0-12.75-8.901-8.32-15.547z"
  })));
};
export default SvgRefresh;